import React from "react";

/*
  THE BUTTERFLY - flat silhouette, split down its mirror axis (x = 93.625) so
  each half hinges on it like a wing. Half the diamond travels with each wing,
  so the two halves never separate. The wingbeat lives in css/mdLoader.css
  (.wL / .wR). The left half bleeds 0.5u under the right to hide the seam.

  GEOMETRY - the upper/lower wing boundary is ONE straight line at 132.427
  degrees, from the diamond's top vertex (93.625, 45.568) through its left
  vertex (54.587, 88.279) and out to the silhouette. It used to kink by 10.284
  degrees at the left vertex; that bend is gone. Right side is the exact mirror
  about x = 93.625.

  TRANSPARENT SEAMS - the facets do not touch. Every internal boundary is
  pulled back by 4u, leaving an 8u see-through gap, the way the original
  Medeata symbol does it. Measured from Medeata200blueSymbol.svg: both of its
  seams are 7.495u wide on a 116.8u-wide mark - 6.42 percent, identical to
  three decimals, so a deliberate parameter rather than a drawing accident.
  The same ratio here would be 11.9u; 8u (4.3 percent) was chosen instead so
  the mark does not come apart at 24px. The gap is cut geometrically, NOT with
  strokes, so it scales cleanly and shows whatever sits behind the mark.

  COLOUR - vertical gradients measured off Irena's reference render (per-region
  least-squares fit over every pixel; all four came out vertical, lighter at the
  top). The reference put the navy on top; here it is INVERTED - light above,
  navy below - which is what lets the mark survive dark grounds. The navy is
  then lifted 25 points of HSL lightness, hue and saturation untouched.

    upper-left   #8cd8ff -> #54abf0      lower wings (both)  #618fde -> #1f61d4
    upper-right  #92ffff -> #57bcc9      diamond             #4fa1ff -> #4696e5

  Do not lift the navy much further: at +30 it falls to 1.53:1 against the
  diamond and the two merge at small sizes. At this +25 it is 1.82:1.

  The gradients are anchored to the CANVAS (0..157.5, userSpaceOnUse), not to
  each region, so a region shows only the slice of its ramp that it covers.
  That is deliberate - it keeps the ramp angle identical at any render size and
  stops the scaleX wingbeat from shearing it.
*/
export default function MedeataMark() {
  return (
    <svg viewBox="0 0 186.5 157.5" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id="mdm-navy" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2="157.5"><stop offset="0" stopColor="#618fde" /><stop offset="1" stopColor="#1f61d4" /></linearGradient>
        <linearGradient id="mdm-sky" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2="157.5"><stop offset="0" stopColor="#8cd8ff" /><stop offset="1" stopColor="#54abf0" /></linearGradient>
        <linearGradient id="mdm-teal" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2="157.5"><stop offset="0" stopColor="#92ffff" /><stop offset="1" stopColor="#57bcc9" /></linearGradient>
        <linearGradient id="mdm-heart" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2="157.5"><stop offset="0" stopColor="#4fa1ff" /><stop offset="1" stopColor="#4696e5" /></linearGradient>
        <clipPath id="mdm-msil"><path d="M93.625 43.25C86.95 43.25 78.706 34.296 73.634 29.887C70.024 26.748 65.912 24.219 62.169 21.245C49.826 11.438 32.926 -4.093 15.793 2.427C-1.07 8.844 1.242 27.197 1.238 41.974C1.234 58.685 1.979 75.529 1.992 92.028C2.009 113.498 -0.933 130.826 17.547 145.836C18.889 146.926 19.689 148.578 21.154 149.523C37.826 160.273 57.245 159.461 72.98 147.468C78.498 143.262 86.891 131.61 93.625 131.25C100.359 131.61 108.752 143.262 114.27 147.468C130.005 159.461 149.424 160.273 166.096 149.523C167.561 148.578 168.361 146.926 169.703 145.836C188.183 130.826 185.241 113.498 185.258 92.028C185.271 75.529 186.016 58.685 186.012 41.974C186.008 27.197 188.32 8.844 171.457 2.427C154.324 -4.093 137.424 11.438 125.081 21.245C121.338 24.219 117.226 26.748 113.616 29.887C108.544 34.296 100.3 43.25 93.625 43.25Z" /></clipPath>
      </defs>
      <g className="wL"><g clipPath="url(#mdm-msil)">
        <path fill="url(#mdm-sky)" d="M94.125 -600L-600 -600L-600 224.454L-314.121 485.749L94.125 39.092Z" />
        <path fill="url(#mdm-navy)" d="M94.125 132.059L93.625 132.554L54.731 94.05L-308.216 491.146L-189.12 600L94.125 600Z" />
        <path fill="url(#mdm-heart)" d="M60.133 88.14L93.625 121.296L94.125 120.801L94.125 52.044L93.625 51.497Z" />
      </g></g>
      <g className="wR"><g clipPath="url(#mdm-msil)">
        <path fill="url(#mdm-teal)" d="M600 -600L93.625 -600L93.625 39.639L501.371 485.749L600 395.602Z" />
        <path fill="url(#mdm-navy)" d="M376.37 600L495.466 491.146L132.519 94.05L93.625 132.554L93.625 600Z" />
        <path fill="url(#mdm-heart)" d="M127.117 88.14L93.625 51.497L93.625 121.296Z" />
      </g></g>
    </svg>
  );
}
